import "core-js/modules/es.array.concat.js";
import { getReq, postReq, putReq } from './axios';
import { employeeBody } from './models';
var BASE_URL = "".concat(apiUrl, "/employee");
export var getAllEmployees = function getAllEmployees() {
  return getReq(BASE_URL);
};
export var getEmployee = function getEmployee(id) {
  return getReq("".concat(BASE_URL, "/").concat(id));
};
export var createEmployee = function createEmployee(body) {
  return postReq(BASE_URL, employeeBody(body));
};
export var updateEmployee = function updateEmployee(id, body) {
  return putReq("".concat(BASE_URL, "/").concat(id), employeeBody(body));
};
export var generate2fa = function generate2fa(userId) {
  return postReq("".concat(apiUrl, "/two-factor/").concat(userId, "/generate"));
};